import React from 'react';

const BASE_TABS = [
  { id: 'overview',     label: 'Overview' },
  { id: 'loading',      label: 'Loading' },
  { id: 'transactions', label: 'Transactions' },
  { id: 'reports',      label: 'Reports' },
  // Given away, not sold. Sits beside Reports because it answers the same kind
  // of question over the same date ranges, but it is a separate set of records
  // and never mixes into the sales figures.
  { id: 'charity',      label: 'Charity' }
];

/**
 * Dashboard tab bar. Admin tab shows only for admins.
 * (Review / Test / Manual-Entry tabs removed with the ANPR flow; Flagged
 * removed at the owner's request — the audit rows are still written, they
 * just no longer have a screen here.)
 */
export default function TabBar({ active, onChange, isAdmin }) {
  const tabs = isAdmin
    ? [...BASE_TABS, { id: 'admin', label: 'Admin' }]
    : BASE_TABS;

  return (
    <div style={{
      display: 'flex', gap: 2, padding: '0 16px',
      borderBottom: '1px solid var(--border)', background: '#fff',
      position: 'sticky', top: 0, zIndex: 10,
    }}>
      {tabs.map(t => {
        const on = active === t.id;
        return (
          <button
            key={t.id}
            onClick={() => onChange(t.id)}
            style={{
              background: 'none', border: 'none', cursor: 'pointer',
              padding: '14px 12px', fontSize: 13, fontWeight: 600,
              fontFamily: "'DM Sans', sans-serif",
              color: on ? 'var(--text-primary)' : 'var(--text-muted)',
              borderBottom: on ? '2px solid #185FA5' : '2px solid transparent',
              transition: 'color .15s',
            }}
          >
            {t.label}
          </button>
        );
      })}
    </div>
  );
}